import { RatingComponent } from './pages/ac/rating/rating.component';
import { ByeComponent } from './pages/bye/bye.component';
import { DashboardComponent } from './pages/ac/dashboard/dashboard.component';
import { AcComponent } from './pages/ac/ac.component';
import { LoginComponent } from './pages/login/login.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartComponent } from './pages/start/start.component';
import { AuthGuard } from './services/auth.guard';
import { ExerciseComponent } from './pages/ac/exercise/exercise.component';
import { NoticesComponent } from './pages/ac/notices/notices.component';
import { RatingGuard } from './services/rating.guard';
import { PreparationComponent } from './pages/ac/preparation/preparation.component';
import { ConferenceComponent } from './pages/ac/conference/conference.component';
import { OnlinetestComponent } from './pages/ac/onlinetest/onlinetest.component';
import { PasswordRenewPasswordComponent } from './pages/password/password-renew-password/password-renew-password.component';
import { PasswordEnterEmailComponent } from './pages/password/password-enter-email/password-enter-email.component';
import { PasswordChangeComponent } from './pages/password/password-change/password-change.component';

const routes: Routes = [
  { path: 's/:type/:hash/:directhash/:acid', component: StartComponent },
  { path: 's/:type/:hash/:directhash', component: StartComponent },
  { path: 's/:type/:hash', component: StartComponent },
  {
    path: 'ac', component: AcComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'exercise/:slot/:group/:candidate', component: ExerciseComponent },
      { path: 'exercise/:slot/:group', component: ExerciseComponent },
      { path: 'rating/:slot/:group/:candidate', component: RatingComponent, canActivate: [RatingGuard] },
      { path: 'rating/:slot/:group', component: RatingComponent, canActivate: [RatingGuard] },
      { path: 'exercise', component: ExerciseComponent },
      { path: 'preparation/:preparation/elements/:element', component: PreparationComponent },
      { path: 'preparation/:preparation', component: PreparationComponent },
      { path: 'onlinetest/:onlinetest', component: OnlinetestComponent, canActivate: [RatingGuard] },
      { path: 'conference', component: ConferenceComponent, canActivate: [RatingGuard] },
      { path: 'notices', component: NoticesComponent },
      { path: 'password-change', component: PasswordChangeComponent },
    ],
    canActivate: [AuthGuard]
  },
  { path: 'login', component: LoginComponent },
  { path: 'password/renew/:email', component: PasswordRenewPasswordComponent },
  { path: 'password', component: PasswordEnterEmailComponent },
  { path: 'bye', component: ByeComponent },
  { path: '**', redirectTo: 'ac/dashboard' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
